import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { PessoaTipoMultiselectComponent } from './pessoa-tipo-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        PessoaTipoMultiselectComponent
    ],
    exports: [
        PessoaTipoMultiselectComponent
    ]
})
export class PessoaTipoMultiselectModule { }
